"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = e => {
    const link = e.target || e || {};
    if (!link || (link && !link.href))
        link['href'] = null;
    let text;
    if (link.eventTitle) {
        text = link.eventTitle;
    }
    else {
        const linkhref = link.href === 'javascript:void(0);' ? null : link.href;
        text =
            !link.textContent || link.textContent === '' || link.textContent === 'X' ? `${link.getAttribute('aria-label')} - ${linkhref}` : `${link.textContent.trim()}- ${linkhref}`;
    }
    if (!text)
        return;
    const analyticsEvent = {};
    if (typeof window.ctConstants === 'undefined')
        return;
    analyticsEvent.eventInfo = {
        type: window.ctConstants.trackEvent,
        eventAction: window.ctConstants.linkClick,
        eventLabel: text,
        eventValue: 1,
    };
    analyticsEvent.category = {
        primaryCategory: window.ctConstants.custom,
    };
    window.digitalData.event.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
